if(jQuery('body').hasClass('page-template-page-gaming')){
    var picksSlickOneCreated = 0,
        picksSlickTwoCreated = 0;
    jQuery(document).ready(function($){
        // PICKS TABS
        var activeTab;
        $('.gaming-odds-picks-tabs a').each(function(){
            if($(this).hasClass('active')){
                activeTab = $(this).data('tab');
            }
        });

        if(jQuery(window).width() < 500){
            jQuery(".gaming-odds-picks-tab .gaming-odds-picks-entry").css({"width": 140, "height": 450});
            setTimeout(function () {
                $(window).trigger('resize');
                if(activeTab == "one"){
                    picksSlickInitializerOne.init();
                    picksSlickOneCreated=1;
                    picksSlickTwoCreated=0;
                }else{
                    picksSlickInitializerTwo.init();
                    picksSlickOneCreated=0;
                    picksSlickTwoCreated=1;
                }
                
            }, 1);
            if(activeTab == "one"){
                picksSlickOneCreated=1;
                picksSlickTwoCreated=0;
            }else{
                picksSlickOneCreated=0;
                picksSlickTwoCreated=1;
            }
        }



        $('.gaming-odds-picks-tabs a').on("click", function(e){
            e.preventDefault();
            if($(this).hasClass('active')){
                return false;
            }else{
                activeTab = $(this).data('tab');

                $('.gaming-odds-picks-tabs a').each(function(){
                    $(this).removeClass('active');
                });

                $(this).addClass('active');

                $('.gaming-odds-picks-tab').each(function(){
                    if($(this).hasClass('show')){
                        $(this).removeClass('show').addClass('hide');
                    }
                });
                

                $('.gaming-picks-tab-'+activeTab).removeClass('hide').addClass('show');

                $('.gaming-picks-tab-'+activeTab+' img').each(function(){
                  if($(this).data('src') !== $(this).attr('src')){
                    $(this).attr('src', $(this).data('src'));
                  }
                })


                if(jQuery(window).width() < 500){
                    if(activeTab == "one"){
                        if(picksSlickOneCreated == 0){
                            picksSlickInitializerOne.init();
                            picksSlickOneCreated=1;
                        }
                    }else{
                        if(picksSlickTwoCreated == 0){
                            picksSlickInitializerTwo.init();
                            picksSlickTwoCreated=1;
                        }
                    }
                }

                
            }
        });
    });


    var picksSlickInitializerOne = {
      init: function () {
        // Slick Featured Products Carousel
        jQuery('.gaming-picks-tab-one').slick({
          infinite: false,
          slidesToShow: 3,
          slidesToScroll: 2,
          prevArrow: '',
          nextArrow: '',
          dots: false,
          speed: 400,
          variableWidth: true,
          lazyLoad: 'progressive',
          responsive: [
            {
              breakpoint: 1024,
              settings: {
                slidesToShow: 3,
                infinite: false
              }
            },
            {
              breakpoint: 767,
              settings: {
                slidesToShow: 1.15,
                slidesToScroll: 0.95,
                infinite: false,
                dots: false
              }
            },
            {
              breakpoint: 480,
              settings: {
                slidesToShow: 2.5,
                slidesToScroll: 1,
                infinite: false,
                dots: false
              }
            }
          ]
              });
      }
    };

    var picksSlickInitializerTwo = {
        init: function () {
          // Slick Featured Products Carousel
          jQuery('.gaming-picks-tab-two').slick({
            infinite: false,
            slidesToShow: 3,
            slidesToScroll: 2,
            prevArrow: '',
            nextArrow: '',
            dots: false,
            speed: 400,
            variableWidth: true,
            lazyLoad: 'progressive',
            responsive: [
              {
                breakpoint: 1024,
                settings: {
                  slidesToShow: 3,
                  infinite: false
                }
              },
              {
                breakpoint: 767,
                settings: {
                  slidesToShow: 1.15,
                  slidesToScroll: 0.95,
                  infinite: false,
                  dots: false
                }
              },
              {
                breakpoint: 480,
                settings: {
                  slidesToShow: 2.5,
                  slidesToScroll: 1,
                  infinite: false,
                  dots: false
                }
              }
            ]
                });
        }
      };
}